import React from 'react'

import { Button, ButtonProps } from '@rmwc/button'
import styled from 'styled-components'
import { ColorProps, SpaceProps, color, space } from 'styled-system'

import { SPACERS } from '~/theme'

type BaseProps = ColorProps & SpaceProps

type CustomButtonProps = ButtonProps &
  BaseProps & {
    iconSize?: number | string
    outline?: boolean
    type?: string
    textTransform?: string
    width?: number | string
    height?: number | string
    borderRadius?: number
    fontSize?: string
    backgroundColor?: string
    onClick?(): void
  }

const StyledButton = styled(Button)<CustomButtonProps>`
  height: ${(props) => props.height || ''};
  width: ${(props) => props.width || '100%'};
  border-radius: ${(props) =>
    props.borderRadius ? `${props.borderRadius}px` : SPACERS.md}; // Use borderRadius property
  border: ${(props) => (props.outline ? `solid 1px ${props.theme.colors.primary}` : 'initial')};
  border-color: ${(props) => (props.disabled ? props.theme.colors.cosmicShade4 : 'initial')};
  text-transform: ${(props) => props.textTransform || 'capitalize'};

  &.mdc-button--raised:not(:disabled),
  &.mdc-button--unelevated:not(:disabled) {
    ${(props) => props.backgroundColor && `background-color:  ${props.backgroundColor}`}
  }

  .mdc-button--dense {
    height: 22px !important;
    font-size: ${SPACERS.sm} !important;
  }

  .mdc-button__icon {
    height: ${(props) => props.iconSize || SPACERS.xl};
    width: ${(props) => props.iconSize || SPACERS.xl};
  }

  .mdc-button__label {
    white-space: nowrap;
    font-size: ${(props) => props.fontSize || '14px'};
  }

  ${space};
  ${color};
`

export const Main = (props: CustomButtonProps) => <StyledButton unelevated {...props} />

export const Secondary = (props: CustomButtonProps) => (
  <StyledButton {...props} color={props.disabled ? 'secondary' : 'primary'} />
)

export const Outline = (props: CustomButtonProps) => <StyledButton {...props} color="primary" outline />

export const PillFilled = (props: CustomButtonProps) => <Main {...props} borderRadius={9999} />
